<template>
	<Newsletter v-if="newsletter" :blok="newsletter" />

	<footer v-if="footer" class="bg-gray-100 text-black m-auto">
		<div class="main-wrapper justify-items-center pb-16 px-8">
			<div
				class="flex md:flex-row md:flex-nowrap flex-wrap py-8 md:py-5 mb-2.5 gap-y-4 md:gap-y-0 w-full border-y border-gray-300"
			>
				<div
					v-for="{ titleKey, contentKey, isSocialMedia } in INFO_CONFIG"
					:key="titleKey"
					class="font-medium text-[15px] flex flex-col gap-2.5 md:gap-4 lg:w-auto md:w-3/12 w-full text-center md:text-left xl:mr-16 xl:pr-16 lg:mr-15 lg:pr-15 md:mr-10 md:pr-10 last:mr-0 flex-grow md:border-r md:border-gray-300 last:border-r-0"
				>
					<span class="font-bold">{{ footer?.[titleKey] }}</span>
					<div
						class="font-light gap-2 flex md:justify-start justify-center"
						:class="isSocialMedia ? '' : 'flex-col'"
					>
						<StoryblokComponent
							v-for="content in footer?.[contentKey]"
							:key="content._uid"
							:blok="content"
							:social-media="isSocialMedia"
						/>
					</div>
				</div>
			</div>
			<div
				class="text-sm font-normal opacity-80 w-full pt-8 text-black text-center flex justify-center items-center"
			>
				© {{ currentYear }}
				<div
					class="ml-2"
					v-html="renderRichText(footer?.footer_copyright)"
				></div>
			</div>
		</div>
		<div class="w-full pb-6 text-center">
			<WithdrawalFooterLink />
		</div>
	</footer>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { StoryblokAppLayout } from "~/types/storyblok/storyblok";

const INFO_CONFIG: Array<{
	titleKey: keyof Pick<
		StoryblokAppLayout,
		"title_footer1" | "title_footer2" | "title_footer3" | "title_footer4"
	>;
	contentKey: keyof Pick<
		StoryblokAppLayout,
		"footer1" | "footer2" | "footer3" | "footer4"
	>;
	isSocialMedia?: boolean;
}> = [
	{
		titleKey: "title_footer1",
		contentKey: "footer1"
	},
	{
		titleKey: "title_footer2",
		contentKey: "footer2"
	},
	{
		titleKey: "title_footer3",
		contentKey: "footer3",
		isSocialMedia: true
	},
	{
		titleKey: "title_footer4",
		contentKey: "footer4"
	}
];

const { footer } = storeToRefs(useAppStore());

const currentYear = ref<number>(new Date().getFullYear());

const newsletter = computed(() => {
	return footer.value?.newsletter?.length ? footer.value.newsletter[0] : null;
});
</script>
